import type { ProcedenciaSaldoOut } from "../../lib/projecao/tipos";

/*
 * Procedência do saldo inicial (FE-2 CP-B — T5). SÓ usada na visão por-empresa
 * (a projeção do grupo não tem procedência — ver nota no contrato `tipos.ts`).
 *
 * Exibe `fonte`, `referencia_em` e `idade_minutos`. `referencia_em`/
 * `idade_minutos` são anuláveis: o backend devolve `null` quando não há semente
 * de saldo conhecida — a UI mostra um marcador claro em vez de "null".
 */

interface ProcedenciaProps {
  procedencia: ProcedenciaSaldoOut;
}

const SEM_VALOR = "—";

export function Procedencia({ procedencia }: ProcedenciaProps): JSX.Element {
  return (
    <dl className="flex flex-wrap gap-x-8 gap-y-1 font-corpo text-base text-off-black">
      <div>
        <dt className="font-subtitulo">Fonte do saldo</dt>
        <dd>{procedencia.fonte}</dd>
      </div>
      <div>
        <dt className="font-subtitulo">Referência</dt>
        <dd>{procedencia.referencia_em ?? SEM_VALOR}</dd>
      </div>
      <div>
        <dt className="font-subtitulo">Idade (minutos)</dt>
        <dd>{procedencia.idade_minutos ?? SEM_VALOR}</dd>
      </div>
    </dl>
  );
}
